import { render } from "./indexGroup.vue?vue&type=template&id=369e021a&scoped=true"
import script from "./indexGroup.vue?vue&type=script&lang=js"
export * from "./indexGroup.vue?vue&type=script&lang=js"

import "./indexGroup.vue?vue&type=style&index=0&id=369e021a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-369e021a"

export default script